import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../../Common/Loader/loader";
import MUITable from "../../../../../Common/MUITable";
import { useTripStore } from "../../store/useTripStore";
import { ExportSATTotalTripReport } from "./ExportSATTotalTripReport";
import { formatDateTime, formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../../../Common/helper/helpar";
import { Modal } from "react-bootstrap";

const SATTotalTripReport = () => {
  const { tripDetails, isFetchingTripDetails } = useTripStore();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
console.log(state)
  // State for text filters
  const [circleFilter, setCircleFilter] = useState("");
  const [vehicleNumberFilter, setVehicleNumberFilter] = useState("");
  const [tsNameFilter, setTsNameFilter] = useState(state?.transferStationName || "");

  // Filter trip details based on user input
  const filteredTripDetails = tripDetails.filter(row => {
    const matchesCircle = circleFilter
      ? row.circle.toLowerCase().includes(circleFilter.toLowerCase())
      : true;
    const matchesVehicleNumber = vehicleNumberFilter
      ? row.vehicleNumber.toLowerCase().includes(vehicleNumberFilter.toLowerCase())
      : true;
    const matchesTsName = tsNameFilter
      ? row?.transferStationName?.toLowerCase()?.includes(tsNameFilter?.toLowerCase())
      : true;
    return matchesCircle && matchesVehicleNumber && matchesTsName;
  });

  const columns = [
    {
      label: "Zone",
      field: "zone",
    },
    {
      label: "Cirlce",
      field: "circle",
    },
    {
      label: "Ward",
      field: "ward",
    },
    {
      label: "Vehicle Type",
      field: "vehicleType",
    },
    {
      label: "Vehicle Number",
      field: "vehicleNumber",
    },
    {
      label: "TS Name",
      field: "transferStationName",
    },
    {
      label: "Driver Name",
      field: "driverName",
    },
    {
      label: "Contact No",
      field: "driverNumber",
    },
    {
      label: "SFA Name",
      field: "primaryDeploymentInchargeName",
    },
    {
      label: "SFA Contact No",
      field: "primaryDeploymentInchargeMobileNumber",
    },
    {
      label: "Trips to TS/SCTP",
      field: "trips",
      render: row => row.trips
    },
    {
      label: "TS/SCTP Name",
      field: "transferStationName",
    },
    {
      label: "Deployment Image",
      field: "transferStationScannedImage",
      render: (row) => {
        return (
          row.transferStationScannedImage ? (
            <img
              src={row.transferStationScannedImage}
              style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px", cursor: "pointer" }}
              onClick={() => handleImageClick(row.transferStationScannedImage)}
            />
          ) : "N/A"
        )
      }
    },
    {
      label: "Reported Time",
      field: "scannedDateTime",
      render: row => row.scannedDateTime ? formatDateTime(row.scannedDateTime) : "N/A"
    },
  ];

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const handleClose = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  return (
    <>
      <div className="content">
        <div className="page-content">
          <div className="page-header">
            <div className="card">
              <div className="card-body">
                {/* Combined Filter and Buttons Section */}
                <div className="filter-section mb-3">
                  <div className="row align-items-end">
                    <div className="col-md-3">
                      <label className="form-label w-100 text-left">
                        Circle
                      </label>
                      <input
                        id="circleFilter"
                        type="text"
                        className="form-control"
                        value={circleFilter}
                        onChange={(e) => setCircleFilter(e.target.value)}
                        placeholder="Enter Circle name..."
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label w-100 text-left">
                        Vehicle Number
                      </label>
                      <input
                        id="vehicleNumberFilter"
                        type="text"
                        className="form-control"
                        value={vehicleNumberFilter}
                        onChange={(e) => setVehicleNumberFilter(e.target.value)}
                        placeholder="Enter Vehicle Number..."
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label w-100 text-left">
                        TS Name
                      </label>
                      <input
                        id="tsNameFilter"
                        type="text"
                        className="form-control"
                        value={tsNameFilter}
                        onChange={(e) => setTsNameFilter(e.target.value)}
                        placeholder="Enter TS Name..."
                      />
                    </div>
                    <div className="col-md-3 d-flex align-items-end">
                      <button
                        className="btn btn-secondary me-2"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </button>
                      <ExportSATTotalTripReport data={filteredTripDetails} datas={state}/>
                    </div>
                  </div>
                </div>
                <div className="top-header">
                  <span>
                    {`${state?.circleName || ""} ${state?.zoneName || ""}`
                      .replace(/Total\s*/gi, "")
                      .trim()} Total Trips
                    ({ state?.FromDateTime && formatDateTimeWithoutSec(state?.FromDateTime)} To { state?.ToDateTime && formatDateTimeWithoutSec(state?.ToDateTime)})
                    (at {getCurrentDateTime1()})
                  </span>

                </div>
                <div>
                  {isFetchingTripDetails && <Loader />}
                  <MUITable
                    needSRNumber
                    rows={filteredTripDetails}
                    columns={columns}
                    tableHeight={500}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showImageModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Full Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={selectedImage}
            alt="Full vehicle"
            style={{ width: "100%", height: "400px", borderRadius: "5px", objectFit: "contain" }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SATTotalTripReport;